import Preloader from './Preloader';

export default Preloader;



// WEBPACK FOOTER //
// ./scripts/elements/Preloader/index.js